import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import Logger from 'browser-logging/src/browser/Logger';

import { MESSAGES } from 'portal/src/constants/snackbarMessages';

import GenericDialog from './GenericDialog';

import useSnackbarHandler from '../../utils/Snackbar/useSnackbarHandler';

interface CopyTextDialogProps {
  open: boolean;
  onClose: () => void;
  textToCopy: string;
  errorMessage?: string;
  title?: string;
  disabledAction?: boolean;
  loading?: boolean;
}

const CopyTextDialog = ({
  open,
  onClose,
  textToCopy,
  errorMessage,
  title = 'User information copy',
  disabledAction = false,
  loading = false,
}: CopyTextDialogProps) => {
  const snackbarHandler = useSnackbarHandler();
  const handleCopy = () => {
    navigator.clipboard.writeText(textToCopy).then(
      () => {
        onClose();
        snackbarHandler.info(MESSAGES.GENERIC.MESSAGE_COPIED);
      },
      (err) => {
        Logger.captureError(err as Error);
        snackbarHandler.error(MESSAGES.GENERIC.ERROR);
      },
    );
  };

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      dialogActions={
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" onClick={onClose}>
            close
          </Button>
          <Button
            variant="contained"
            disabled={disabledAction || loading}
            color="secondary"
            disableElevation
            onClick={handleCopy}
          >
            Copy
          </Button>
        </Stack>
      }
    >
      <Stack justifyContent="center" alignItems="center" width="100%">
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            {errorMessage ? (
              <Typography>{errorMessage}</Typography>
            ) : (
              <Card variant="outlined" sx={{ width: '100%' }}>
                <CardHeader
                  title={title}
                  subheader="Copy the information below to your clipboard"
                />
                <CardContent>
                  <TextField
                    fullWidth
                    inputProps={{
                      readOnly: true,
                    }}
                    value={textToCopy}
                  />
                </CardContent>
              </Card>
            )}
          </>
        )}
      </Stack>
    </GenericDialog>
  );
};

export default CopyTextDialog;
